import { render } from "./company-users.vue?vue&type=template&id=6c845813&ts=true"
import script from "./company-users.vue?vue&type=script&lang=ts"
export * from "./company-users.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__